/** Suspense fallback — branded, never a blank screen. `full` covers the viewport. */
export const PageLoader = ({ full = false }) => (
  <div className={`${full ? 'min-h-screen' : 'min-h-[60vh]'} grid place-items-center`} data-testid="page-loader">
    <div className="flex flex-col items-center gap-3">
      <div className="h-9 w-9 rounded-full border-2 border-border border-t-primary animate-spin" />
      <p className="text-[10px] text-muted-foreground font-grotesk uppercase tracking-[0.2em]">Loading</p>
    </div>
  </div>
);

export default PageLoader;
